import React, { useState } from "react";
import { useSelector } from "react-redux";
import { selectors } from "rdx";

import { PrimaryButton } from "components/mui-styled-components";
import RightArrow2 from "components/Icons/Arrows/rightArrow2";
import { DownCaretFilled } from "components/Icons";
import HorizontalTimeline from "components/mui-styled-components/HorizontalTimeline";
import { theme } from "styles/themes";
import * as S from "./styles";

export type VisionProposalTeamDisplayPropsT = {
  inProgressHeader?: string;
  nextStepsTitle?: string;
  nextStepsText?: string;
  designLabel?: string;
};

const VisionProposalTeamDisplay = ({
  inProgressHeader = "Your proposal is in progress",
  nextStepsTitle = "Next: Add finance & equipment details",
  nextStepsText = "Help your design team create an accurate proposal by adding your financing preferences and equipment selections in Vision.",
  designLabel = "Powur Design Team",
}: VisionProposalTeamDisplayPropsT) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const leadDetails = useSelector(selectors.selectLeadToProposalLeadDetails);
  const projectDetails = useSelector(selectors.selectLeadToProposalProjectDetails);
  const { proposalNotes, requestType } = useSelector(selectors.selectLeadToProposalRequestDetails);
  const visionTurnaround = { realtime: "Expedited", "over-night": "Standard" };

  const openVisionInNewTab = () => {
    const visionProposalUrl = `${process.env.REACT_APP_VISION_CLIENT_URL}/proposal/${projectDetails.visionProposal.slug}`;
    window.open(visionProposalUrl, "_blank", "noopener,noreferrer");
  };
  return (
    <S.VisionRequestCompleteContainer>
      <S.VisionProposalCard>
        <S.VisionProposalInProgressHeader>{inProgressHeader}</S.VisionProposalInProgressHeader>
        <HorizontalTimeline
          timelineData={[
            { label: "Request Sent", content: <></>, disabled: true },
            { label: "Add Details", content: <></>, disabled: true },
            { label: "Design Complete", content: <></>, disabled: true },
          ]}
          currentTab={1}
          setCurrentTab={() => null}
        />
        <S.VisionNextStepsCard>
          <S.VisionNextStepsTitle>{nextStepsTitle}</S.VisionNextStepsTitle>
          <S.VisionNextStepsText>{nextStepsText}</S.VisionNextStepsText>
        </S.VisionNextStepsCard>
        <PrimaryButton gradient onClick={openVisionInNewTab} width="100%" height="56px">
          <S.VisionButtonText>
            Continue to Vision <RightArrow2 width="22" fill={theme.colors.white} />
          </S.VisionButtonText>
        </PrimaryButton>
      </S.VisionProposalCard>
      <S.HomeownerDetailsContainer>
        <S.Divider />
        <S.DetailsRow>
          <S.HomeownerDetailsLabel>Homeowner</S.HomeownerDetailsLabel>
          <S.DetailsText>{leadDetails?.fullName}</S.DetailsText>
        </S.DetailsRow>
        <S.DetailsRow>
          <S.HomeownerDetailsLabel>Address</S.HomeownerDetailsLabel>
          <S.DetailsText>
            {leadDetails?.address?.street}, {leadDetails?.address?.city} {leadDetails?.address?.state}
          </S.DetailsText>
        </S.DetailsRow>
        <S.DetailsRow>
          <S.HomeownerDetailsLabel>Design</S.HomeownerDetailsLabel>
          <S.DetailsText>
            {designLabel} ({visionTurnaround[requestType]})
          </S.DetailsText>
        </S.DetailsRow>
        <S.Divider />
        <S.HomeownerDetailsLabel>Proposal Request Notes</S.HomeownerDetailsLabel>
        <S.ProposalNotesText>{proposalNotes}</S.ProposalNotesText>
      </S.HomeownerDetailsContainer>
      <S.ExpandableSection>
        <S.ExpandableSectionHeader onClick={() => setIsExpanded(!isExpanded)}>
          Turnaround times & service hours
          <S.RotatingIconContainer isRotated={isExpanded}>
            <DownCaretFilled fill={theme.colors["blue-ribbon"]} height="12" width="12" />
          </S.RotatingIconContainer>
        </S.ExpandableSectionHeader>
        {isExpanded && (
          <>
            <S.TurnaroundTimeSection>
              <S.DetailsRow>
                <S.DetailsText>Standard Requests</S.DetailsText>
                <S.DetailsTextDark>Within 90 Minutes</S.DetailsTextDark>
              </S.DetailsRow>
              <S.Divider />
              <S.DetailsRow>
                <S.DetailsText>Expedited Requests</S.DetailsText>
                <S.DetailsTextDark>Within 30 Minutes</S.DetailsTextDark>
              </S.DetailsRow>
            </S.TurnaroundTimeSection>
            <S.ServiceHoursCard>
              <S.ServiceHoursLabel>Service Hours (PT)</S.ServiceHoursLabel>
              <S.ServiceHoursText>Mon-Fri: 5 AM - 8 PM</S.ServiceHoursText>
              <S.ServiceHoursText>Sat-Sun: 9 AM - 8 PM</S.ServiceHoursText>
              <S.ServiceHoursText>Holidays: Varies</S.ServiceHoursText>
            </S.ServiceHoursCard>
          </>
        )}
      </S.ExpandableSection>
    </S.VisionRequestCompleteContainer>
  );
};

export default VisionProposalTeamDisplay;
